<p class="share-toggle-text"*ngIf="!inherited" [transloco]="translationKey"></p>
<p class="share-toggle-text" *ngIf="inherited">
  <svg-icon class="share-toggle-text__icon" key="lock-alt" [fontSize]="'1.2em'"></svg-icon>
  <span [transloco]="'sharePanel.toggleText.inherited'"></span>
</p>
